const createWhimErrorTypes = {
  INVALID_WHIM_PRICE: 'storekeepers.cant_add_whims_max_price_exceeded',
};
export default createWhimErrorTypes;
